<template>
  <div>
    <el-table
      v-if="showTable"
      :data="subjectScoreList"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      :cell-style="cellStyle"
      :span-method="arraySpanMethod"
      empty-text="ไม่พบข้อมูล"
      class="score-table"
      :default-sort = "{prop: 'index', order: 'ascending'}"
    >
      <el-table-column
        v-if="showAction"
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        width="80"
        class="text-center"
      ></el-table-column>
      <el-table-column
        prop="label"
        label="รายวิชา"
        header-align="center"
        :width="widthMax < 767.98 ? '170' : ''"
      >
      </el-table-column>

      <el-table-column
        prop="preTest"
        label="แบบทดสอบก่อนเรียน"
        header-align="center"
        align="center"
        :width="widthMax < 767.98 ? '80' : widthMax < 991.98 ? '100' : '120'"
      >
        <template slot-scope="scope">
          <span
            v-if="typeof scope.row.preTest == 'number'"
            class="pd-x-4 text-font-16"
            :class="!courseScoreList.startLearn?'color-danger-lighter':subjectSuccess == false?'color-warning':!pass &&new Date().setHours(0,0,0,0) > new Date(courseScoreList.durationTime.close).getTime()?'color-danger-lighter':pass ?'color-success':'color-warning'"
          >
            {{subjectSuccess == false || !courseScoreList.startLearn?'':pass || (!pass &&new Date().setHours(0,0,0,0) > new Date(courseScoreList.durationTime.close).getTime())?scope.row.preTest.toFixed(0):''}}
            {{ 
              !courseScoreList.startLearn?"ยังไม่ได้เรียน"
              :subjectSuccess == false && (pass || (!pass &&new Date().setHours(0,0,0,0) > new Date(courseScoreList.durationTime.close).getTime()))?'รออัปเดตบทเรียน'
              :pass ? "% ผ่าน" 
              :!pass &&new Date().setHours(0,0,0,0) > new Date(courseScoreList.durationTime.close).getTime()?'% ไม่ผ่าน'
              : "กำลังเรียนอยู่" 
            }}
          </span>
          <span v-else>
            <span v-if="Date.now() < new Date(scope.row.open).getTime()" class="color-gray">
              วิชายังไม่เปิด
            </span>
            <span v-else-if="scope.row.havePreTest == false">
              -
            </span>
            <span v-else-if="scope.row.preTestDone">
              {{ scope.row.preTest}}
            </span>
            <span v-else class="color-danger-lighter">
              ยังไม่ได้ทำข้อสอบ
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="discussionForum"
        label="กระดานถาม - ตอบระหว่างเรียน"
        header-align="center"
        align="center"
        :width="widthMax < 767.98 ? '80' : widthMax < 991.98 ? '100' : '120'"
      >
        <template slot-scope="scope">
          <span v-if="Date.now() < new Date(scope.row.open).getTime()" class="color-gray">
            วิชายังไม่เปิด
          </span>
          <span v-else-if="scope.row.haveDiscussion == false">
              -
          </span>
          <span v-else-if="scope.row.discussionForum" class="pd-x-4 color-success">
            <i class="fas fa-check"></i>
          </span>
          <span v-else class="color-danger-lighter">ยังไม่ได้ตอบคำถาม</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="assignment"
        label="งานที่ได้รับมอบหมาย"
        header-align="center"
        align="center"
        :width="widthMax < 767.98 ? '80' : widthMax < 991.98 ? '100' : '120'"
      >
        <template slot-scope="scope">
          <span v-if="Date.now() < new Date(scope.row.open).getTime()" class="color-gray">
            วิชายังไม่เปิด
          </span>
          <span v-else-if="scope.row.haveAssignment == false">-</span>
          <span v-else-if="scope.row.takeAssignment == false" class="color-danger-lighter">ยังไม่ได้ส่ง</span>
          <div v-else-if="edit == 'false'">
            <span v-if="scope.row.assignment" class="pd-x-4 color-success">
              <i class="fas fa-check"></i>
            </span>
            <span v-else class="color-warning">รอตรวจ</span>
          </div>
          <el-checkbox
            v-else
            @change="checkAssignment(scope.row.id, !scope.row.assignment)"
            :value="scope.row.assignment"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
        prop="postTest"
        label="แบบทดสอบหลังเรียน"
        header-align="center"
        align="center"
        :width="widthMax < 767.98 ? '80' : widthMax < 991.98 ? '100' : '120'"
      >
        <template slot-scope="scope">
          <span>
            <span v-if="Date.now() < new Date(scope.row.open).getTime()" class="color-gray">
              วิชายังไม่เปิด
            </span>
            <span v-else-if="scope.row.havePostTest == false">
              -
            </span>
            <span v-else-if="scope.row.postTestDone">
              {{ scope.row.postTest}}
            </span>
            <span v-else class="color-danger-lighter">
              ยังไม่ได้ทำข้อสอบ
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="video"
        label="วีดิโอ"
        header-align="center"
        align="center"
        :width="widthMax < 767.98 ? '80' : widthMax < 991.98 ? '100' : '120'"
      >
        <template slot-scope="scope">
          <span v-if="Date.now() < new Date(scope.row.open).getTime()" class="color-gray">
            วิชายังไม่เปิด
          </span>
          <span v-else-if="scope.row.haveTopic == false">
            -
          </span>
          <span v-else-if="scope.row.video" class="pd-x-4 color-success">
            <i class="fas fa-check"></i>
          </span>
          <span v-else-if="scope.row.takeTopic" class="color-warning">กำลังเรียน</span>
          <span v-else class="color-danger-lighter">ยังไม่ได้เรียน</span>
        </template>
      </el-table-column>
      <el-table-column
          v-if="showUpdatedAt"
          prop="updatedAt"
          label="วันที่และเวลาที่อัปเดต"
          :width="
            widthMax < 767.98
              ? '160'
              : widthMax < 1199
              ? '160'
              : widthMax > 1200
              ? '250'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row.updatedAt | dateTimeTh
          }}</template>
        </el-table-column>
      <el-table-column
        v-if="showAction"
        label
        width="50"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="flex-display ai-center js-center">
            <div class="box-action">
              <div
                @click="
                  $router.push(
                    `/activity/assigment?edit=${$route.query.edit}&courseId=${courseId}&subjectId=${scope.row.id}&userId=${userId}`
                  )
                "
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-eye"></i>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";

export default {
  props: {
    showAction: {
      type: Boolean,
      default() {
        return false;
      },
    },
    showUpdatedAt: {
      type: Boolean,
      default() {
        return false;
      },
    },
    edit: {
      type: String,
      default() {
        return "false";
      },
    },
    courseScoreList: {
      type: Object,
      default() {
        return null;
      },
    },
    courseId: {
      type: String,
      default() {
        return "";
      },
    },
    userId: {
      type: String,
      default() {
        return "";
      },
    },
    subjectSuccess: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      subjectScoreList: [],
      totalScore: 0,
      pass: true,
    };
  },
  watch: {
    courseScoreList() {
      this.setSubjectScoreList();
    },

  },
  mounted() {
    this.setSubjectScoreList();
    window.addEventListener("resize", this.resize);
    
  }, 
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    setSubjectScoreList() {
      if (this.courseScoreList && this.courseScoreList.subjects.length > 0) {
        this.subjectScoreList = [];
         let subjects = this.courseScoreList.subjects.sort((a,b)=>{
          if (a.index > b.index) return 1
          if (a.index < b.index) return -1
          return 0
        })
        
        subjects.map((item) => {
          this.subjectScoreList.push({
            id: item._id,
            label: `วิชาที่ ${item.index} ${item.name}`,
            preTest: item.preTestTotal > 0 ? `${item.preTestScore}/${item.preTestTotal}` : '-',
            discussionForum: item.discussion == 100 ? true : false,
            assignment: item.assignment == 100 ? true : false,
            postTest: item.postTestTotal > 0 ? `${item.postTestScore}/${item.postTestTotal}` : '-',
            video: item.topic >= 100 ? true : false,
            haveTopic: item.haveTopic,
            haveAssignment: item.haveAssignment,
            havePreTest: item.havePreTest,
            haveDiscussion: item.haveDiscussion,
            havePostTest: item.havePostTest,
            takeAssignment: item.takeAssignment,
            open: item.durationTime.open,
            preTestDone: item.preTestDone,
            postTestDone: item.postTestDone,
            takeTopic: item.takeTopic,
            updatedAt: item.updatedAt,
          });
        });

        this.subjectScoreList.push({
          id: "total",
        });

        this.totalScore = this.courseScoreList.percent
          ? this.courseScoreList.percent
          : 0;
        this.pass = this.courseScoreList.pass;
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == this.subjectScoreList.length - 1) {
        if (this.showAction) {
          if (columnIndex == 1) {
            return "text-align: right;";
          }
        } else {
          if (columnIndex == 0) {
            return "text-align: right;";
          }
        }
      }
      return "";
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == this.subjectScoreList.length - 1) {
        if (this.showAction) {
          if (columnIndex == 0) {
            return [0, 0];
          } else if (columnIndex == 1) {
            row.label = "สรุปคะแนนรวม (%)";
            return [1, 2];
          } else if (columnIndex == 2) {
            row.preTest = this.totalScore;
            return [1, 6];
          }

          if (rowIndex == this.subjectScoreList.length -1 && (columnIndex == 3 || columnIndex == 4 || columnIndex == 5 || columnIndex == 6 || columnIndex == 7)) {
            return [0, 0];
          }
        } else {
          if (columnIndex == 0) {
            row.label = "สรุปคะแนนรวม (%)";
          } else if (columnIndex == 1) {
            row.preTest = this.totalScore;
            if (this.showUpdatedAt) {
              return [1, 6];
            }else{
              return [1, 5];
            }
            
          }

          if (rowIndex == this.subjectScoreList.length -1 && (columnIndex == 2 || columnIndex == 3 || columnIndex == 4 || columnIndex == 5)) {
            return [0, 0];
          }
        }
      }
    },
    checkAssignment(id, status) {
      this.$emit("checkAssignment", id, status);
    },
  },
};
</script>

<style scoped></style>
